export const UPDATE_PORTAL_MAP_DATA = "UPDATE_PORTAL_MAP_DATA";

export function actionUpdatePortalMapData(data) {
  return { type: UPDATE_PORTAL_MAP_DATA, data };
}
